var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 3.33337H4.16602C3.50297 3.33337 2.86709 3.59677 2.39825 4.06561C1.92941 4.53445 1.66602 5.17033 1.66602 5.83337V14.1667C1.66602 14.8297 1.92941 15.4656 2.39825 15.9345C2.86709 16.4033 3.50297 16.6667 4.16602 16.6667H15.8327C16.4957 16.6667 17.1316 16.4033 17.6005 15.9345C18.0693 15.4656 18.3327 14.8297 18.3327 14.1667V5.83337C18.3327 5.17033 18.0693 4.53445 17.6005 4.06561C17.1316 3.59677 16.4957 3.33337 15.8327 3.33337ZM15.491 5.00004L10.591 9.90004C10.5135 9.97815 10.4214 10.0401 10.3198 10.0824C10.2183 10.1248 10.1094 10.1465 9.99935 10.1465C9.88934 10.1465 9.78042 10.1248 9.67887 10.0824C9.57732 10.0401 9.48515 9.97815 9.40768 9.90004L4.50768 5.00004H15.491ZM16.666 14.1667C16.666 14.3877 16.5782 14.5997 16.4219 14.756C16.2657 14.9122 16.0537 15 15.8327 15H4.16602C3.945 15 3.73304 14.9122 3.57676 14.756C3.42048 14.5997 3.33268 14.3877 3.33268 14.1667V6.17504L8.23268 11.075C8.70143 11.5432 9.33685 11.8062 9.99935 11.8062C10.6619 11.8062 11.2973 11.5432 11.766 11.075L16.666 6.17504V14.1667Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendMail);
export default __webpack_public_path__ + "static/media/ic-send-mail.4ec534c856a8571786ede47193de50e6.svg";
export { ForwardRef as ReactComponent };